import React, { useState, useEffect } from "react";

interface DatetimeBoxProps {
  initialDate: Date;
}

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
//const monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const DateBox: React.FC<DatetimeBoxProps> = ({ initialDate }) => {
  const [date, setDate] = useState<Date>(initialDate);

  useEffect(() => {
    let midnightTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59
    ).getTime();
    var timeToMidnight = midnightTime - date.getTime();
    setTimeout(() => {
      setDate(new Date(date.getDate() + 1));
    }, timeToMidnight); // Update at midnight
  }, [date]);

  return (
    <div className="box">
      <span id="yearBg">{date.getFullYear()}</span>
      <p>{monthNames[date.getMonth()] + ", " + date.getDate()}</p>
    </div>
  );
};

const TimeBox: React.FC<DatetimeBoxProps> = ({ initialDate }) => {
  const [time, setTime] = useState<Date>(initialDate);

  useEffect(() => {
    setTimeout(() => {
      setTime(new Date(time.getTime() + 60000));
    }, 60000); // Update minute
  }, [time]);

  let hours: number = time.getHours();
  let minutes: number = time.getMinutes();
  let ampm: string = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;

  return (
    <div className="box">
      <img src={require("./assets/images/clock.png")} alt="" />
      <p>
        {" "}
        {(hours ? hours : 12) +
          ":" +
          (minutes < 10 ? "0" : "") +
          minutes +
          " " +
          ampm}
      </p>
    </div>
  );
};

const DatetimeBox: React.FC<DatetimeBoxProps> = ({ initialDate }) => {
  return (
    <React.Fragment>
      <DateBox initialDate={initialDate} />
      <TimeBox initialDate={initialDate} />
    </React.Fragment>
  );
};

export default DatetimeBox;
export { TimeBox, DateBox };
